import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqItems = [{
  question: "Quelle est votre approche méthodologique pour les projets complexes ?",
  answer: "Nous adoptons une approche structurée et fluide, débutant par un audit stratégique approfondi, suivi d'une planification rigoureuse et d'une exécution orientée résultats. Cette méthode garantit la cohérence de vos messages et maximise l'impact auprès de vos cibles B2B."
}, {
  question: "Quels sont vos modèles d'engagement contractuel ?",
  answer: "Nous proposons des modèles flexibles adaptés aux exigences des organisations : un engagement au projet pour des missions ponctuelles (livrables spécifiques), ou un modèle en régie (retainer) pour un accompagnement stratégique continu sur le long terme."
}, {
  question: "Quels sont les délais typiques pour la réalisation d'un projet ?",
  answer: "Les délais varient selon l'envergure du mandat. Un audit stratégique nécessite généralement 2 à 3 semaines, tandis qu'une refonte de branding ou l'organisation d'un événement professionnel majeur peut requérir 4 à 8 semaines de préparation minutieuse."
}, {
  question: "Comment garantissez-vous la confidentialité des informations ?",
  answer: "La confidentialité est au cœur de notre éthique professionnelle. Nous signons systématiquement des accords de non-divulgation (NDA) stricts et appliquons des protocoles de sécurité rigoureux pour protéger vos données stratégiques et sensibles."
}, {
  question: "Intervenez-vous uniquement au Burkina Faso ?",
  answer: "Bien que notre ancrage soit au Burkina Faso, notre expertise en communication stratégique et événementiel nous permet d'accompagner des organisations et institutions à travers toute la sous-région, avec la même exigence de qualité."
}];
export default function FaqInstitutionnelle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="faq-institutionnelle" className="bg-card py-20 sm:py-28 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl opacity-50 mix-blend-screen" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/5 rounded-full blur-3xl opacity-50 mix-blend-screen" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-serif font-medium tracking-tight text-foreground mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Des réponses claires sur nos méthodes, nos engagements et notre
              fonctionnement pour vous accompagner en toute transparence.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border border-border/50 bg-background/50 px-6 rounded-lg data-[state=open]:bg-background/80 data-[state=open]:border-border transition-all duration-300" data-index={i}>
                <AccordionTrigger className="text-left hover:no-underline py-6 group">
                  <span className="text-base sm:text-lg font-medium text-foreground group-hover:text-primary transition-colors">
                    {item.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}